module.exports = __webpack_public_path__ + "static/media/step1.419c301b.jpg";